import React, { useEffect, useState, useMemo } from 'react';
import { Stack } from '@mui/material';
import { AppConfig } from '../config';
import { underscoreToSpace } from './strings';
import { loadImage } from '../sections/AssetLogo';

const PaymentMethodsLogo = React.memo(({ paymentMethod, size, ...props }: any) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const fullSrc = useMemo(() => {
    return paymentMethod?.logo ? `${AppConfig.apiRoot}files/image-asset/${paymentMethod?.logo}` : `${AppConfig.apiRoot}files/image-asset/UNKNOWN.png`;
  }, [paymentMethod?.logo]);

  useEffect(() => {
    loadImage(fullSrc)
      .then((cachedSrc) => {
        setImageSrc(cachedSrc);
      })
      .catch((error) => console.error('Error loading image:', error));
  }, [fullSrc]);
  return (
    <Stack direction="row" spacing={-1.5} mt={1} {...props}>
      <img
        src={imageSrc || undefined}
        alt={paymentMethod?.id ? underscoreToSpace(paymentMethod?.id) : 'UNKNOWN'}
        style={{ width: size === 'xs' ? 25 : 50, height: size === 'xs' ? 25 : 50 }}
      />
    </Stack>
  );
});
export default PaymentMethodsLogo;
